import { VBtn } from 'vuetify/lib/components/VBtn';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "main",
    { staticClass: "rate-fraud-free-content" },
    [
      _c(_setup.RateFraudFreeBanner, {
        staticClass: "mb-4",
        attrs: { "cash-reward": _setup.cashReward },
      }),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "d-flex flex-column gr-8",
          class: { "px-2": _setup.isMobile },
        },
        [
          _c(
            "section",
            {
              staticClass:
                "rate-fraud-free-content__section text-body-1 text--text d-flex flex-column gr-3",
            },
            [
              _c("h2", { staticClass: "text-h6" }, [
                _vm._v(
                  "\n        " +
                    _vm._s(_setup.t("О программе", _setup.options)) +
                    "\n      "
                ),
              ]),
              _vm._v(" "),
              _c("p", [
                _vm._v(
                  "\n        " +
                    _vm._s(
                      _setup.t(
                        "На сайте ПроДокторов участились случаи публикации ложных отзывов.",
                        _setup.options
                      )
                    ) +
                    "\n        "
                ),
                _vm._v(
                  "\n        " +
                    _vm._s(
                      _setup.t(
                        "Некоторые клиники и врачи придумали, как обойти проверку: стали выдавать фальшивые документы, подтверждающие факт приёма, и заказывать недостоверные отзывы.",
                        _setup.options
                      )
                    ) +
                    "\n        "
                ),
              ]),
              _vm._v(" "),
              _c("p", [
                _vm._v(
                  "\n        " +
                    _vm._s(
                      _setup.t(
                        "Чтобы защитить пациентов, которые выбирают специалистов по отзывам на ПроДокторов, и обеспечить равные условия для врачей и клиник, мы запустили программу «Отзывы без обмана».",
                        _setup.options
                      )
                    ) +
                    "\n        "
                ),
              ]),
              _vm._v(" "),
              _c("p", [
                _vm._v(
                  "\n        " +
                    _vm._s(
                      _setup.t(
                        "Вы сможете получить вознаграждение до ",
                        _setup.options
                      )
                    ) +
                    _vm._s(_setup.cashReward) +
                    ", " +
                    _vm._s(
                      _setup.t(
                        "если сообщите об опубликованном заказном отзыве и предоставите доказательства.",
                        _setup.options
                      )
                    ) +
                    "\n        " +
                    _vm._s(
                      _setup.t(
                        "Портал применит санкции к клиникам и врачам, которые решили обмануть пациентов.",
                        _setup.options
                      )
                    ) +
                    "\n        "
                ),
              ]),
            ]
          ),
          _vm._v(" "),
          _setup.context.request.country.is_russia
            ? _c(
                _setup.AlertInfo,
                { staticClass: "mt-n4" },
                [
                  _c("div", { staticClass: "text-body-2 text--text" }, [
                    _vm._v(
                      "\n        " +
                        _vm._s(
                          _setup.t(
                            "Уже раскрыли более 30 врачей и клиник, которые заказывали отзывы",
                            _setup.options
                          )
                        ) +
                        "\n      "
                    ),
                  ]),
                  _vm._v(" "),
                  _c(
                    VBtn,
                    {
                      staticClass: "mt-2",
                      attrs: {
                        small: "",
                        href: _setup.reverseFull({ name: "shame_mark" }),
                        color: "primary",
                        elevation: "0",
                      },
                    },
                    [
                      _vm._v(
                        "\n        " +
                          _vm._s(_setup.t("Смотреть список", _setup.options)) +
                          "\n      "
                      ),
                    ]
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "section",
            {
              staticClass:
                "rate-fraud-free-content__section text-body-1 text--text d-flex flex-column gr-3",
            },
            [
              _c("h2", { staticClass: "text-h6" }, [
                _vm._v(
                  "\n        " +
                    _vm._s(
                      _setup.t(
                        "Сообщите о заказном отзыве, если вы",
                        _setup.options
                      )
                    ) +
                    "\n      "
                ),
              ]),
              _vm._v(" "),
              _c("ol", [
                _c("li", [
                  _vm._v(
                    "\n          " +
                      _vm._s(
                        _setup.t(
                          "Физическое лицо, достигшее 18-летнего возраста.",
                          _setup.options
                        )
                      ) +
                      "\n          " +
                      _vm._s(
                        _setup.t(
                          "И получили заказ от клиники или врача на написание недостоверного отзыва на ПроДокторов.",
                          _setup.options
                        )
                      ) +
                      "\n        "
                  ),
                ]),
                _vm._v(" "),
                _c("li", [
                  _vm._v(
                    "\n          " +
                      _vm._s(_setup.t("Клиника или врач.", _setup.options)) +
                      " " +
                      _vm._s(
                        _setup.t(
                          "И добровольно признаетесь, что заказывали написание и публикацию отзывов на ПроДокторов.",
                          _setup.options
                        )
                      ) +
                      "\n          "
                  ),
                ]),
              ]),
            ]
          ),
          _vm._v(" "),
          _c(
            "section",
            {
              staticClass:
                "rate-fraud-free-content__section text-body-1 text--text d-flex flex-column gr-3",
            },
            [
              _c("h2", { staticClass: "text-h6" }, [
                _vm._v(
                  "\n        " +
                    _vm._s(
                      _setup.t("Как сообщить о заказном отзыве", _setup.options)
                    ) +
                    "\n      "
                ),
              ]),
              _vm._v(" "),
              _c("ol", [
                _c("li", [
                  _c("p", { staticClass: "mb-2" }, [
                    _vm._v(
                      "\n            " +
                        _vm._s(
                          _setup.t(
                            "Напишите на электронную почту",
                            _setup.options
                          )
                        ) +
                        " "
                    ),
                    _c(
                      "a",
                      {
                        staticClass: "primary--text link-decoration-underline",
                        attrs: { href: "mailto:proverka@medrocket.ru" },
                      },
                      [_vm._v("proverka@medrocket.ru.")]
                    ),
                    _vm._v(
                      "\n            " +
                        _vm._s(_setup.t("Укажите:", _setup.options)) +
                        "\n          "
                    ),
                  ]),
                  _vm._v(" "),
                  _c("ul", { staticClass: "d-flex flex-column gr-1" }, [
                    _c("li", [
                      _vm._v(
                        "\n              " +
                          _vm._s(
                            _setup.t(
                              "номер телефона, который использовали при оставлении отзыва",
                              _setup.options
                            )
                          ) +
                          "\n            "
                      ),
                    ]),
                    _vm._v(" "),
                    _c("li", [
                      _vm._v(
                        "\n              " +
                          _vm._s(
                            _setup.t(
                              "видеозапись переписки со ссылкой на страницу клиники или врача, ценой, содержанием отзыва",
                              _setup.options
                            )
                          ) +
                          "\n            "
                      ),
                    ]),
                    _vm._v(" "),
                    _c("li", [
                      _vm._v(
                        "\n              " +
                          _vm._s(
                            _setup.t(
                              "документ, подтверждающий получение денежных средств от заказчика",
                              _setup.options
                            )
                          ) +
                          "\n            "
                      ),
                    ]),
                    _vm._v(" "),
                    _c("li", [
                      _vm._v(
                        "\n              " +
                          _vm._s(
                            _setup.t(
                              "фальшивые документы, которые заказчик предоставил для подтверждения отзыва: чеки, договоры, медицинские заключения, выписки",
                              _setup.options
                            )
                          ) +
                          "\n            "
                      ),
                    ]),
                    _vm._v(" "),
                    _c("li", [
                      _vm._v(
                        "\n              " +
                          _vm._s(
                            _setup.t(
                              "иные документы по запросу портала ПроДокторов.",
                              _setup.options
                            )
                          ) +
                          "\n            "
                      ),
                    ]),
                  ]),
                ]),
              ]),
            ]
          ),
          _vm._v(" "),
          _c(
            "section",
            {
              staticClass:
                "rate-fraud-free-content__section text-body-1 text--text d-flex flex-column gr-3",
            },
            [
              _c("h2", { staticClass: "text-h6" }, [
                _vm._v(
                  "\n        " +
                    _vm._s(
                      _setup.t("Как получить вознаграждение", _setup.options)
                    ) +
                    "\n      "
                ),
              ]),
              _vm._v(" "),
              _c("p", [
                _vm._v(
                  "\n        " +
                    _vm._s(
                      _setup.t(
                        "Специалисты портала ПроДокторов проверят доказательства в течение 5 рабочих дней.",
                        _setup.options
                      )
                    ) +
                    "\n      "
                ),
              ]),
              _vm._v(" "),
              _c("p", [
                _vm._v(
                  "\n        " +
                    _vm._s(
                      _setup.t(
                        "После этого свяжутся с вами, чтобы уточнить реквизиты для выплаты вознаграждения.",
                        _setup.options
                      )
                    ) +
                    "\n      "
                ),
              ]),
            ]
          ),
          _vm._v(" "),
          _c(
            "section",
            {
              staticClass:
                "rate-fraud-free-content__section text-body-1 text--text d-flex flex-column gr-3",
            },
            [
              _c("h2", { staticClass: "text-h6" }, [
                _vm._v(
                  "\n        " +
                    _vm._s(
                      _setup.t("Санкции. Что важно знать", _setup.options)
                    ) +
                    "\n      "
                ),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "d-flex flex-column gr-2" }, [
                _c("h3", { staticClass: "text-subtitle-1" }, [
                  _vm._v(
                    "\n          " +
                      _vm._s(
                        _setup.t("Авторам заказных отзывов", _setup.options)
                      ) +
                      "\n        "
                  ),
                ]),
                _vm._v(" "),
                _c("p", [
                  _vm._v(
                    "\n          " +
                      _vm._s(
                        _setup.t(
                          "На портале ПроДокторов все отзывы такого пользователя будут аннулированы, а аккаунт заблокирован.",
                          _setup.options
                        )
                      ) +
                      "\n          "
                  ),
                ]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "d-flex flex-column gr-2" }, [
                _c("h3", { staticClass: "text-subtitle-1" }, [
                  _vm._v(
                    "\n          " +
                      _vm._s(_setup.t("Заказчикам", _setup.options)) +
                      "\n        "
                  ),
                ]),
                _vm._v(" "),
                _c("p", [
                  _vm._v(
                    "\n          " +
                      _vm._s(
                        _setup.t(
                          "Таким клиникам и врачам ПроДокторов заблокирует любые возможности для продвижения на портале и обнулит их рейтинг.",
                          _setup.options
                        )
                      ) +
                      "\n          " +
                      _vm._s(
                        _setup.t(
                          "На личной странице пациенты увидят предупреждающий баннер.",
                          _setup.options
                        )
                      ) +
                      "\n          "
                  ),
                ]),
              ]),
            ]
          ),
          _vm._v(" "),
          _c("p", { staticClass: "text-body-1 text--text" }, [
            _vm._v(
              "\n      " +
                _vm._s(_setup.t("Подробнее читайте в", _setup.options)) +
                " "
            ),
            _c(
              "a",
              {
                staticClass: "primary--text link-decoration-underline",
                attrs: { href: "/info/rate-fraud-free-rules/" },
              },
              [_vm._v(_vm._s(_setup.t("Правилах программы", _setup.options)))]
            ),
            _vm._v(".\n      "),
            _c("br"),
            _vm._v(
              "\n      " +
                _vm._s(
                  _setup.t(
                    "Если у вас остались вопросы, обратитесь по почте",
                    _setup.options
                  )
                ) +
                " "
            ),
            _c(
              "a",
              {
                staticClass: "primary--text link-decoration-underline",
                attrs: { href: "mailto:proverka@medrocket.ru" },
              },
              [_vm._v("proverka@medrocket.ru")]
            ),
          ]),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }